/*
* Copyright (C) Regione Lombardia
*/
import { Component } from '@angular/core';
import { NavigationCancel, NavigationEnd, NavigationError, NavigationStart, Router } from '@angular/router';
import { applyUserTab } from '@core/utilities';
import { UtilsService } from '@shared/services/utils.service';

applyUserTab();

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
})
export class AppComponent {

    constructor(
        private utilsService: UtilsService,
        private router: Router,
    ) {
        this.router.events.subscribe(event => {
            if (event instanceof NavigationEnd || event instanceof NavigationError || event instanceof NavigationCancel) {
                this.utilsService.inNavigationLoading(false);
            }
            if (event instanceof NavigationStart) {
                this.utilsService.inNavigationLoading(true);
            }
        });
    }

}
